/** @format */
export { Intercom } from './components/intercom';
